import React from 'react';

export const Comment = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="17"
      height="17"
      transform="translate(0 0.833984)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.54025 8.98919C3.54025 6.83727 5.76512 5.08627 8.5 5.08627C11.2349 5.08627 13.4598 6.83727 13.4598 8.98919C13.4598 11.1418 11.2349 12.8921 8.5 12.8921C5.76512 12.8921 3.54025 11.1418 3.54025 8.98919ZM14.0519 14.4936V14.4922C14.0519 14.4922 12.9441 12.8914 13.5086 12.2851L13.4824 12.2992C14.3515 11.3897 14.875 10.2401 14.875 8.98919C14.875 6.05527 12.0155 3.66748 8.5 3.66748C4.98454 3.66748 2.125 6.05456 2.125 8.98919C2.125 11.9238 4.98454 14.3116 8.5 14.3116C9.50583 14.3116 10.455 14.1097 11.3029 13.7619C12.0133 14.4859 12.9228 14.8754 13.5979 14.9796L13.5993 14.9774C13.6365 14.9914 13.6757 14.9993 13.7155 15.0008C13.7757 15.0008 13.835 14.9859 13.888 14.9573C13.9411 14.9288 13.9863 14.8876 14.0195 14.8374C14.0528 14.7872 14.0731 14.7295 14.0786 14.6695C14.0841 14.6095 14.0754 14.5491 14.0519 14.4936Z"
      fill={color || '#7D7A9A'}
    />
    <path
      d="M11.3333 7.20915L5.66667 7.20915C5.27546 7.20915 4.95833 7.52628 4.95833 7.91748C4.95833 8.30868 5.27546 8.62581 5.66667 8.62581L11.3333 8.62581C11.7245 8.62581 12.0417 8.30868 12.0417 7.91748C12.0417 7.52628 11.7245 7.20915 11.3333 7.20915Z"
      fill={color || '#7D7A9A'}
    />
    <path
      d="M7.79167 9.33415H5.66667C5.27546 9.33415 4.95833 9.65128 4.95833 10.0425C4.95833 10.4337 5.27546 10.7508 5.66667 10.7508H7.79167C8.18287 10.7508 8.5 10.4337 8.5 10.0425C8.5 9.65128 8.18287 9.33415 7.79167 9.33415Z"
      fill={color || '#7D7A9A'}
    />
  </svg>
);
